import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
    from {
        transform: translateX(-100%);
    }
    to {
        transform: translateX(100%);
    }
`;

const Shimmer = styled.div`
    position: relative;
    overflow: hidden;
    background: #ececec;
    &::after {
        content: "";
        position: absolute;
        inset: 0;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.7), transparent);
        animation: ${shimmer} 1.4s infinite;
    }
`;

// ─── Layout — mirrors GatewayCardGrid ────────────────────────────────────────

export const GridWrapper = styled.div`
    width: 100%;
`;

export const CardGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
    gap: 24px;
`;

// ─── Card shell — mirrors GatewayCard.styles ──────────────────────────────────

export const Card = styled.div`
    width: 100%;
    max-width: 380px;
    height: 100%;
    max-height: 420px;
    background: #ffffff;
    border: 1px solid #d6d6d6;
    border-radius: 16px;
    overflow: hidden;
    box-sizing: border-box;
    justify-self: stretch;
    align-self: stretch;
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 16px;
`;

export const HeaderLeft = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
`;

export const HeaderRight = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    flex-shrink: 0;
`;

export const Line = styled(Shimmer)<{
    width: string;
    height?: number;
}>`
    width: ${({ width }) => width};
    height: ${({ height = 14 }) => `${height}px`};
    border-radius: 6px;
`;

export const StatusBadge = styled(Shimmer)`
    width: 72px;
    height: 24px;
    border-radius: 12px;
`;

export const ActionDot = styled(Shimmer)`
    width: 20px;
    height: 20px;
    border-radius: 50%;
`;

export const Divider = styled.div`
    border-top: 1px solid #ebebeb;
`;

export const Section = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 12px 16px;
`;

export const Label = styled(Shimmer)`
    width: 120px;
    height: 14px;
    border-radius: 6px;
`;

export const Input = styled(Shimmer)`
    width: 100%;
    height: 40px;
    border-radius: 10px;
`;

export const Chips = styled.div`
    display: flex;
    gap: 8px;
`;

export const Chip = styled(Shimmer)`
    width: 100px;
    height: 34px;
    border-radius: 10px;
`;

// ─── Pagination skeleton ──────────────────────────────────────────────────────

export const Pagination = styled.div`
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const Summary = styled(Shimmer)`
    width: 140px;
    height: 18px;
    border-radius: 6px;
`;

export const Pages = styled.div`
    display: flex;
    gap: 10px;
`;

export const Page = styled(Shimmer)`
    width: 36px;
    height: 36px;
    border-radius: 8px;
`;

export const Rows = styled(Shimmer)`
    width: 160px;
    height: 40px;
    border-radius: 10px;
`;
